import { ComponentPropsWithoutRef, ReactNode } from "react";
import icon from "./assets/icons/telegram.svg";

export type TelegramButtonProps = ComponentPropsWithoutRef<"a"> & {
  href: string;
  ariaLabel: string;
  children: ReactNode;
};

export const TelegramButton = ({
  href,
  ariaLabel,
  className,
  children,
  ...props
}: TelegramButtonProps) => {
  return (
    <a
      role="button"
      className="telegram-button"
      aria-label={ariaLabel}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      <span className="telegram-button-content">
        <img src={icon} alt="Ícone Telegram" className="social-icon" />
        {children}
      </span>
    </a>
  );
};
